module.exports = __webpack_public_path__ + "static/media/img31.8a346bb4.jpg";